var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.297,
    height: 12.597,
    viewBox: "0 0 12.297 12.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8249",
    "data-name": "Rectangle 8249",
    width: 12.297,
    height: 12.597,
    transform: "translate(0 0)",
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15700",
    "data-name": "Group 15700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M6.367,6.231h0a.808.808,0,0,0-.2-.463L1.444.3A.813.813,0,0,0,.182,1.328c.012.015.024.029.031.035L4.481,6.3.218,11.232a.813.813,0,0,0,1.19,1.108l.031-.036L6.17,6.835a.817.817,0,0,0,.2-.6",
    transform: "translate(0 -0.002)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M46.454,6.229h0a.808.808,0,0,0-.2-.463L41.531.3a.813.813,0,0,0-1.263,1.025c.012.015.024.029.031.036L44.568,6.3,40.3,11.23a.813.813,0,0,0,1.19,1.108l.031-.036,4.731-5.47a.817.817,0,0,0,.2-.6",
    transform: "translate(-34.159 0)",
    fill: "#065683"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrow);
export default __webpack_public_path__ + "static/media/filter-arrow.1c8789d0f62f7f8e819ccf1677a79468.svg";
export { ForwardRef as ReactComponent };